import { Customer } from "app/common/Model/Customer";
import {
  getOrCreateNewByServiceRequestItemId,
  markServiceAsCompletedByServiceRequestItem,
  undoCreateNewDiagnosticReportByServiceRequestItemId,
  undoMarkServiceAsCompletedByServiceRequestItem,
} from "app/services/DiagnosticReportService";
import {
  getInitReportOfSvItem,
  updateParticipantsAndReportOfSvItem,
} from "app/services/ServiceRequestItemService";
import { saveServiceRequestItemWithStepsAfterComplete } from "app/services/ServiceRequestItemStepService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
import history from "history.js";
import { store } from "app/stores";

const DEFAULT_VALUE_PATIENT = {
  patientInfo: new Customer(),
  checkinList: [],
  patientAdviceList: [],
};

export default class TreatmentResultsInfoDetailStore {
  currentTab = 0;
  initReportOfSvItem = null;

  initialPatient = {
    ...DEFAULT_VALUE_PATIENT,
  };
  openConfirmComplete = false;
  openConfirmUndoCompletedTreatment = false;
  openConfirmUndoStartTreatment = false;
  openConfirmMessage = null;
  permissionErrorMessage = null;
  _savingParticipants = false;

  constructor() {
    makeAutoObservable(this);
  }

  setCurrentTab = (tab) => {
    this.currentTab = tab;
  };

  handGetInitReportOfSvItem = async (serviceRequestItem) => {
    try {
      let { data } = await getInitReportOfSvItem(serviceRequestItem);
      if (
        data?.responseStatus === false &&
        data?.responseCode === "PERMISSION_ERROR"
      ) {
        this.permissionErrorMessage = data?.responseDetail;
        store.treatmentManagementStore.treatmentListAllStore.errorMessage =
          data?.responseDetail;
        store.treatmentManagementStore.treatmentListStore.permissionErrorMessage =
          data?.responseDetail;

        if (
          history.location.pathname.includes("treatment-update-results-detail")
        ) {
          // if (history.length > 1) {
          //   history.goBack();
          // } else {
            history.push("/treatment-management/treatment-list-all");
          // }
        }
        return;
      }
      if (!data?.diagnosticReport) {
        this.initReportOfSvItem = {
          ...data,
          diagnosticReport: {
            performDate: new Date(),

            performRoom: null,
          },
        };
      } else {
        this.initReportOfSvItem = { ...data };
      }

      this.initialPatient = data?.encounter?.patient;
    } catch (error) {
      toast.error(error);
    }
  };

  handUpdateParticipantsAndReportOfSvItem = async (values) => {
    if (this._savingParticipants) {
      return;
    }
    this._savingParticipants = true;
    try {
      const { data } = await updateParticipantsAndReportOfSvItem(values);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          if (data?.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = data?.responseDetail;
          } else {
            this.openConfirmMessage = data?.responseDetail;
          }
        }, 500);
      } else {
        if (data?.id) {
          toast.success("Cập nhật thành công");
          this.handGetInitReportOfSvItem({ id: data?.id });
        } else {
          toast.error("Cập nhật thất bại");
        }
      }
    } catch (error) {
      toast.error(error);
    } finally {
      this._savingParticipants = false;
    }
  };

  handSaveServiceRequestItemWithStepsAfterComplete = async (values) => {
    try {
      const { data } = await saveServiceRequestItemWithStepsAfterComplete(
        values
      );
      if (data?.responseStatus === false) {
        setTimeout(() => {
          if (data?.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = data?.responseDetail;
          } else {
            this.openConfirmMessage = data?.responseDetail;
          }
        }, 500);
      } else if (data?.id) {
        toast.success("Cập nhật tour thành công");
        this.handGetInitReportOfSvItem({ id: data?.id });
      } else {
        toast.error("Cập nhật tour thất bại");
      }
    } catch (error) {
      toast.error(error);
    }
  };

  handleStartTreatment = async (id) => {
    try {
      const { data } = await getOrCreateNewByServiceRequestItemId(id);
      if (data?.responseStatus === false) {
        setTimeout(() => {
          if (data?.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = data?.responseDetail;
          } else {
            this.openConfirmMessage = data?.responseDetail;
          }
        }, 500);
        return false;
      }
      return true;
    } catch (error) {
      toast.error(error);
      return false;
    }
  };

  handleConfirmMarkCompletedService = async (id) => {
    try {
      const { data } = await markServiceAsCompletedByServiceRequestItem(id);
      if (data?.responseStatus === false) {
        this.handleCloseConfirmComplete(); // Close the confirmation popup
        setTimeout(() => {
          if (data?.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = data?.responseDetail;
          } else {
            this.openConfirmMessage = data?.responseDetail;
          }
        }, 500);
      } else {
        toast.success("Đánh dấu hoàn thành thành công");
        this.handleCloseConfirmComplete();
        this.handGetInitReportOfSvItem({ id: data?.requestItemId });
      }
    } catch (error) {
      this.handleCloseConfirmComplete(); // Also close on exception
      toast.error(error);
    }
  };

  handleUndoCompletedTreatment = async (id) => {
    try {
      const { data } = await undoMarkServiceAsCompletedByServiceRequestItem(id);
      if (data?.responseStatus === false) {
        this.handleCloseConfirmUndoCompletedTreatment();
        setTimeout(() => {
          if (data?.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = data?.responseDetail;
          } else {
            this.openConfirmMessage = data?.responseDetail;
          }
        }, 500);
      } else {
        toast.success("Đã hủy đánh dấu hoàn thành");
        this.handleCloseConfirmUndoCompletedTreatment();

        this.handGetInitReportOfSvItem({ id: data?.requestItemId });
      }
    } catch (error) {
      this.handleCloseConfirmUndoCompletedTreatment();
      toast.error(error);
    }
  };

  handleUndoStartTreatment = async (id) => {
    try {
      const { data } =
        await undoCreateNewDiagnosticReportByServiceRequestItemId(id);
      if (data?.[0]?.responseStatus === false) {
        this.handleCloseConfimrUndoStartTreatment();
        setTimeout(() => {
          if (data?.[0]?.responseCode === "PERMISSION_ERROR") {
            this.permissionErrorMessage = data?.[0]?.responseDetail;
          } else {
            this.openConfirmMessage = data?.[0]?.responseDetail;
          }
        }, 500);
      } else {
        toast.success("Đã hủy điều trị");
        this.handleCloseConfimrUndoStartTreatment();

        this.handGetInitReportOfSvItem({ id: data?.[0]?.requestItemId });
      }
    } catch (error) {
      this.handleCloseConfimrUndoStartTreatment();
      toast.error(error);
    }
  };

  handleCloseConfirmComplete = () => {
    this.openConfirmComplete = false;
  };

  handleOpenConfimrUndoCompletedTreatment = () => {
    this.openConfirmUndoCompletedTreatment = true;
  };

  handleOpenConfirmComplete = () => {
    this.openConfirmComplete = true;
  };

  handleOpenConfimrUndoStartTreatment = () => {
    this.openConfirmUndoStartTreatment = true;
  };

  handleCloseConfirmUndoCompletedTreatment = () => {
    this.openConfirmUndoCompletedTreatment = false;
  };

  handleCloseConfimrUndoStartTreatment = () => {
    this.openConfirmUndoStartTreatment = false;
  };

  handleCloseConfirmMessage = () => {
    this.openConfirmMessage = null;
  };

  handleClosePermissionMessage = () => {
    this.permissionErrorMessage = null;
  };

  resetStore = () => {
    this.initReportOfSvItem = null;
    this.initialPatient = {
      ...DEFAULT_VALUE_PATIENT,
    };
    this.openConfirmMessage = null;
    this.permissionErrorMessage = null;
  };
}
